<template>
  <div>
    <a-card style="border: none; border-radius: 12px" title="开始培训">
      <a-row :gutter="50">
        <a-col
          :sm="12"
          :md="12"
          :lg="12"
          :xl="6"
          v-for="item in dataList"
          :key="item.id"
        >
          <div
            class="train_type_box"
            @click="goPage('/train/trainPlay', { id: item.id })"
          >
            <div class="img_box">
              <div>
                {{
                  item.name
                }}
              </div>
            </div>
            <div class="text_box">
              <div class="text_box_left">{{ item.name }}</div>
            </div>
            <div class="text_box_top">
              <!-- 时长：{{ formatSeconds(item.classes_time) }} -->
              时长：{{
                item.classes ? item.classes.split(",").length + "课时" : "0课时"
              }}
            </div>
          </div>
        </a-col>
        <a-empty v-if="dataList.length == 0" />
      </a-row>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import { formatSeconds } from "@/utils/util";
export default {
  mixins: [viewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trainProgram/page",
      },
    };
  },
  methods: {
    formatSeconds,
    goPage(path, query) {
      this.$router.push({ path: path, query });
    },
  },
};
</script>

<style scoped lang="scss">
.train_type_box {
  // width: 330px;
  // height: 239px;
  background: #f5f6fa;
  box-sizing: border-box;
  padding: 20px 20px;
  cursor: pointer;

  .img_box {
    width: 100%;
    height: 140px;
    box-sizing: border-box;
    padding: 0 20px;
    background-image: url("~@/assets/image/train_img.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 20px;
    color: #fff;
    font-weight: bold;
    font-size: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    div {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      line-height: 45px;
    }
  }

  .text_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text_box_left {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #212121;
    }

    // .text_box_right {
    //   font-size: 12px;
    //   font-family: Source Han Sans CN;
    //   font-weight: 400;
    //   color: #9BA2AB;
    // }
  }

  .text_box_top {
    padding-top: 5px;
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #0073ff;
  }
}
</style>